// extracted by mini-css-extract-plugin
module.exports = {"Modal":"buyerEmailModal_Modal__39hqJ","RootModal":"buyerEmailModal_RootModal__hkByk","Form":"buyerEmailModal_Form__1kEYC","Button":"buyerEmailModal_Button__2wZVP"};